export default "__VITE_ASSET__DKwmh8iY__"